import React, { useState } from 'react';
import QuantityInput from '@ajat/design-system/QuantityInput';
import { ComponentPage, DemoCard, DemoRow, Demo } from '../shared';

export const meta = {
  component: QuantityInput,
  title: 'QuantityInput',
  group: 'Forms',
  importPath: '@ajat/design-system/QuantityInput',
  figmaNode: '3797:15947',
  description:
    'Compact [− value +] stepper for cart rows and product configurators. The stepper buttons disable at min and max, and errors surface in a tooltip below the field rather than pushing layout around.',
  props: [
    ['value', 'number', '—', 'Controlled value'],
    ['defaultValue', 'number', '1', 'Initial value (uncontrolled)'],
    ['min', 'number', '0', 'Minimum — the minus button disables here'],
    ['max', 'number', '99', 'Maximum — the plus button disables here'],
    ['step', 'number', '1', 'Increment per click'],
    ['onChange', 'func', '—', 'Fires with the new numeric value'],
    ['error', 'string', "''", 'Error message, shown as a tooltip below'],
    ['disabled', 'bool', 'false', 'Disables the whole control'],
    ['className', 'string', "''", 'Additional CSS class'],
    ['id', 'string', '—', 'Id of the hidden input'],
    ['name', 'string', '—', 'Name of the hidden input'],
  ],
  usage: [
    {
      title: 'In a cart row',
      code: `import QuantityInput from '@ajat/design-system/QuantityInput';

<QuantityInput
  value={item.quantity}
  min={1}
  max={99}
  onChange={(qty) => updateProductQty(item.id, qty)}
/>`,
    },
  ],
};

export default function QuantityInputPage() {
  const [qty, setQty] = useState(2);

  return (
    <ComponentPage meta={meta}>
      <DemoCard title="States">
        <DemoRow>
          <Demo caption="DEFAULT"><QuantityInput defaultValue={1} /></Demo>
          <Demo caption="WITH VALUE"><QuantityInput defaultValue={5} /></Demo>
          <Demo caption="MIN REACHED (0)"><QuantityInput defaultValue={0} min={0} /></Demo>
          <Demo caption="MAX REACHED (5)"><QuantityInput defaultValue={5} max={5} /></Demo>
          <Demo caption="DISABLED"><QuantityInput defaultValue={3} disabled /></Demo>
        </DemoRow>
      </DemoCard>

      <DemoCard title="Error" hint="the tooltip is absolute — it does not change the row height">
        <div className="pb-[32px]">
          <QuantityInput defaultValue={1} error="The count can't be 0" />
        </div>
      </DemoCard>

      <DemoCard title="Controlled" hint={`current value: ${qty}`}>
        <QuantityInput value={qty} onChange={setQty} min={1} max={10} />
      </DemoCard>
    </ComponentPage>
  );
}
